<!--  eslint-disable -->
<template>
  <v-container>
    <section class="ma-3 mb-0">
      <Transportadora />
    </section>
    <!-- <v-alert class="mt-3 ma-3" text dense color="info" border="left">
      <h3 class="alert-title">Instruções</h3>
      <li class="alert-list__item">
        Para iniciar o parcelamento selecione um tipo de receita abaixo.
      </li>
      <li class="alert-list__item">
        Para ver seus parcelamentos e baixar o DAE clique em
        <strong>MEUS PARCELAMENTOS</strong>.
      </li>
    </v-alert> -->
    <v-card class="ma-3 pa-6 elevation-0">
      <section class="d-flex flex-column flex-lg-row flex-sm-column">
        <v-spacer></v-spacer>
        <DialogMeusParcelamentos :contribuinte="transportadora.razaosocial" />
      </section>
      <v-divider></v-divider>
      <v-alert v-if="semReceitas" class="mt-4" type="warning" text border="left" prominent>
        <strong>Nenhuma receita disponível para parcelamento.</strong><br />
        Não foram encontradas receitas aptas para parcelamento vinculadas ao seu CNPJ/CPF.
      </v-alert>
      <!-- <DialogSimulation
        @updateList="val => loadDashboard()"
        :listCards="listCards"
        :qtd="lisqtdProdutos"
      /> -->
    </v-card>
    <section class="ma-3 mt-2 mb-0">
      <!-- <v-btn
          color="green"
          class="ml-2 mb-2 white--text"
          @click="prepareDataPDFXML('EXCEL')"
        >
          <v-icon left dark>article</v-icon>
          Excel
        </v-btn>
  
        <v-btn
          color="blue"
          class="ml-2 mb-2 white--text"
          @click="prepareDataPDFXML('PDF')"
        >
          <v-icon left dark>picture_as_pdf</v-icon>
          PDF
        </v-btn> -->
    </section>
    <section class="ma-3 mt-0">
      <!-- <DataTableNegociacion /> -->
    </section>
    <AceiteTermosParcelamentoDialog />
  </v-container>
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import DataTableNegociacion from './DatatableNegociation.vue';
// import DialogSimulation from './DialogSimulation.vue';
// import Cards from "./components/Cards.vue";
import NewNegociation from '../../../../services/financeiro/new-negociation.service';
import transportadoraAuthService from '@/services/transportadora.auth.service';
import { router } from '@/router';
import DialogMeusParcelamentos from './DialogMeusParcelamentos.vue';
import AceiteTermosParcelamentoDialog from './components/AceiteTermosParcelamentoDialog.vue';
import Transportadora from '@/components/layout/Transportadora.vue';
export default Vue.extend({
  name: 'Financeiro',
  components: {
    // DataTableNegociacion,
    // DialogSimulation,
    DialogMeusParcelamentos,
    AceiteTermosParcelamentoDialog,
    Transportadora,
    // Cards,
  },
  data: () => ({
    listCards: [
      {
        name: 'Multas',
        idReceita: 4,
        disabled: true,
        list: [
          {
            name: 'Multas Penalidade',
            idProduto: 12,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Multas Administrativas da Cagece - FESB',
            idProduto: 18,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Multas Contratuais',
            idProduto: 11,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Multas',
            idProduto: 7,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Multas de Transporte - Parcelamento',
            idProduto: 19,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
        ],
      },
      {
        name: 'Taxa',
        idReceita: 1,
        disabled: true,
        list: [
          {
            name: 'Taxa de Regulação do Serviço de Gás Canalizado',
            idProduto: 1,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Taxa de Regulação do Serviço de Saneamento Básico',
            idProduto: 2,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
        ],
      },

      {
        name: 'Honorários Advocatícios',
        idReceita: 6,
        disabled: true,
        list: [
          {
            name: 'Honorários Advocatícios',
            idProduto: 10,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
        ],
      },
      {
        name: 'Receita da ARCE',
        idReceita: 7,
        disabled: true,
        list: [
          {
            name: 'Outorga de Serviços de Transporte Rodoviário',
            idProduto: 16,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
        ],
      },
      {
        name: 'Taxa Transporte',
        idReceita: 2,
        disabled: true,
        list: [
          {
            name: 'Taxa de Regulação do Serviço de Transporte Intermunicipal de Passageiros - jan/2008 a dez/2011 - 60% Arce / 40% Detran',
            idProduto: 3,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Taxa de Regulação do Serviço de Transporte Intermunicipal de Passageiros - até dez/2007',
            idProduto: 4,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Taxa de Regulação do Serviço de Transporte Intermunicipal de Passageiros - a partir de jan/2012 - 75% Arce / 25% Detran',
            idProduto: 5,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Taxa de Regulação do Serviço de Transporte Intermunicipal de Passageiros - 100% Arce',
            idProduto: 9,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
          {
            name: 'Taxa de Regulação de Transporte (100% ARCE)',
            idProduto: 14,
            icon: 'article',
            data: { count: 0 },
            disabled: true,
          },
        ],
      },
    ],
    getListCard: [],
    dashboardLoaded: false,
    lisqtdProdutos: [],
    paginationAptas: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['dataVencimento'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
      size: 5,
    },
  }),
  methods: {
    searchSefazReceita() {
      NewNegociation.listSefazReceita(this.transportadora.cnpj).subscribe(
        res => {
          res.map(e => {});
        },
        error => {
          if (error.response.data.status == 401) {
            this.logout();
          }
        }
      );
    },
    // countSefazProduto(sefazProdutoId) {
    //   if (sefazProdutoId) {
    //     const { sortBy, sortDesc, page, itemsPerPage, size } =
    //       this.paginationAptas;

    //     return new Promise((resolve, reject) => {
    //       NewNegociation.countSefazProdutos({
    //         cpfCnpj: this.transportadora.cnpj,
    //         idSefazProduto: sefazProdutoId,
    //         naoAptas: false,
    //         ascendingSort: sortDesc[0],
    //         page: page,
    //         size: size,
    //         sort: sortBy,
    //       }).subscribe(
    //         (res) => resolve(res),
    //         (err) => reject(err)
    //       );
    //     });
    //   } else {
    //     return Promise.resolve(null);
    //   }
    // },
    // async searchSefazProduto(data) {
    //   for (const card of this.listCards) {
    //     // Pode ser necessário armazenar ou ignorar o retorno
    //     await this.countSefazProduto(card.id);

    //     for (const item of card.list) {
    //       try {
    //         const result = await this.countSefazProduto(item.idProduto);
    //         item.disabled = result.count == 0; // ou outra lógica baseada no valor
    //         item.data = result;
    //       } catch (err) {
    //         console.error("Erro ao buscar produto:", item.idProduto, err);
    //         item.disabled = true; // ou algum fallback
    //       }
    //     }
    //   }
    // },
    loadDashboard() {
      const { sortBy, sortDesc, page, itemsPerPage, size } = this.paginationAptas;
      NewNegociation.countSefazProdutos({
        cpfCnpj: this.transportadora.cnpj,
        naoAptas: false,
        ascendingSort: sortDesc[0],
        page: page,
        size: size,
        sort: sortBy,
      }).subscribe(
        res => {
          // console.log(res);
          // const lista = this.listCards.flatMap(
          //   (e) =>
          //     (e.list = e.list.map((p) => {
          //       res.find((r) => p.idProduto == r.sefazProdutoId);
          //     }))
          // );
          const resMap = new Map(res.map(r => [r.sefazProdutoId, r]));
          this.listCards.forEach(card => {
            card.list.forEach(item => {
              item.data = resMap.get(item.idProduto);
            });
            card.disabled = card.list.every(produto => !produto.data || produto.data.count === 0);
          });
          this.dashboardLoaded = true;
        },
        err => {}
      );
    },
    logout() {
      transportadoraAuthService.logout();
    },
  },
  computed: {
    ...mapState('transportadora', ['transportadora']),
    semReceitas() {
      return this.dashboardLoaded && this.listCards.every(card => card.disabled);
    },
  },
  mounted() {
    this.loadDashboard();
  },
});
</script>
